import * as React from 'react';

import {NewUserSplashScreen} from './new-user-splash-screen';
import {NoLicenseSplashScreen} from './no-license-splash-screen';

import styles from './no-access.module.css';

type Props = {
    shouldWelcome: boolean;
};

export function NoAccessRoot(props: Props) {
    const SplashScreenComponent = props.shouldWelcome ? NewUserSplashScreen : NoLicenseSplashScreen;

    return (
        <div className={styles['no-access-container']}>
            <SplashScreenComponent />
        </div>
    );
}
